import { Link } from "react-router-dom";
import { KeyRound, Megaphone, Store } from "lucide-react";
import { themeOf, tint } from "@/lib/mall";

/** Whose sign is this? Every owned block on the floor says so, in that shop's colors. */
export default function StoreTag({ card, note, className = "" }) {
    if (!card) return null;
    const t = themeOf(card);
    return (
        <Link to={`/stores/${card.slug}`} data-testid={`store-tag-${card.slug}`}
            className={`accent-ink inline-flex w-fit items-center gap-2 rounded-full border px-3.5 py-1.5 font-mono text-[11px] uppercase tracking-[0.18em] transition-transform duration-200 hover:scale-[1.03] ${className}`}
            style={{ borderColor: tint(t.primary, 0.45), color: t.ink || t.primary, background: tint(t.primary, 0.08), "--neon": t.neon || t.primary }}>
            <Store size={11} /> {card.name}{note ? ` · ${note}` : ""}
        </Link>
    );
}

/** Every rented sign in the hallway says it's a billboard, and whose it is. */
export function BillboardTag({ card, className = "" }) {
    const t = themeOf(card);
    return (
        <span className={`accent-ink inline-flex w-fit items-center gap-2 rounded-full border px-3.5 py-1.5 font-mono text-[11px] uppercase tracking-[0.22em] ${className}`}
            style={{ borderColor: tint(t.tertiary || t.primary, 0.6), color: t.ink || t.primary, background: tint(t.tertiary || t.primary, 0.12), "--neon": t.tertiary || t.neon || t.primary }}
            data-testid={`billboard-tag-${card?.slug || "house"}`}>
            <Megaphone size={11} /> Billboard
        </span>
    );
}

/** Mall-owned blocks carry this instead — nobody's shop. Grey for rooms, amber for the office. */
export function MallTag({ className = "", label = "Every shop", office = false }) {
    return (
        <span data-testid={office ? "mall-office-tag" : "mall-tag"}
            className={`inline-flex w-fit items-center gap-2 rounded-full border px-3.5 py-1.5 font-mono text-[11px] uppercase tracking-[0.18em] ${office ? "border-amber-300 bg-amber-50 text-amber-700" : "border-zinc-300 bg-zinc-50 text-zinc-700"} ${className}`}>
            {office ? <KeyRound size={11} /> : <Store size={11} />} {label}
        </span>
    );
}
